import clsx from 'clsx';
import { FC } from 'react';

import StyleButtonComponent, { getButtonClassName } from 'components/digifi-wrappers/Button/StyleButtonComponent';
import Button, { ButtonProps } from 'product_modules/components/Button';

const ButtonStyled = StyleButtonComponent(Button, 'root');

const ButtonWrapper: FC<ButtonProps> = (props) => {
  return (
    <ButtonStyled
      {...props}
      className={clsx(getButtonClassName(props.kind), props.className)}
    />
  );
};

export default ButtonWrapper;
